/* app/js/src/components/common/date-time-picker/date-time-picker.component.scss */
:host {
  position: relative;
}
.format-date {
  display: flex;
}
.format-date span {
  margin-right: 5px;
}
.format-date .toggle-pickers {
  cursor: pointer;
}
.format-date ::ng-deep svg path {
  fill: #40c4ff;
}
.pickers {
  background: #fff;
  width: max-content;
  z-index: 4;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid #e1e6eb;
  flex-direction: column;
  align-items: stretch;
  position: absolute;
  left: 115px;
}
/*# sourceMappingURL=date-time-picker.component.css.map */
